import { put, select } from 'redux-saga/effects'
import { takeLatest } from '@redux-saga/core/effects'
import { addMedicationAdministeredItem } from '../../timeline/store/timeline.actions'
import { getQuickActionsSelector } from '../selectors/quickActions.selector'
import { setAddMedicationToTimeline } from '../store/quickActions.actions'
import { AddMedicationAdministeredConstants } from '../../addMedicationAdministered/store/addMedicationAdministered.constants'
import { resetState } from '../../addMedicationAdministered/store/addMedicationAdministered.actions'

export function* saveMedicationQuickActionTimeLineRow() {
  const quickActionsObject = yield select(getQuickActionsSelector)
  const { addMedicationToTimeline } = quickActionsObject
  if (addMedicationToTimeline) {
    yield put(addMedicationAdministeredItem())
    yield put(resetState())
    yield put(setAddMedicationToTimeline(false))
  }
}

export function* saveMedicationQuickActionTimeLineRowSaga() {
  yield takeLatest([AddMedicationAdministeredConstants.SET_RESPONSE], saveMedicationQuickActionTimeLineRow)
}
